module.exports = __webpack_public_path__ + "static/media/inventory-type-name.81d1f6e5.svg";